import * as React from "react";
import { withApollo } from "@apollo/client/react/hoc";
import Text from "components/LegacyText";
import PageContent from "components/Layout/PageContent";
import styles from "./styles.scss";
import { intercomSelector } from "../Intercom";

function Footer() {
  return (
    <PageContent gutter narrow className={styles.footerContainer}>
      <footer className={styles.footer}>
        <Text.P2 kind="secondary">
          Need help?{" "}
          <Text.Link kind="blue" className={intercomSelector}>
            Contact support
          </Text.Link>
          .
        </Text.P2>
      </footer>
    </PageContent>
  );
}

export default withApollo(Footer) as React.ComponentType<{}>;
